
/**
 * Turn event information into links for various calendar applications
 * 
 * Help from:
 * https://douglascayers.com/2019/06/22/how-to-send-google-and-outlook-calendar-invite-links-in-email-templates/
 * 
 */

function toQueryString(params) {
    return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

function toOutlookLink(event) {
    const details = {
        subject: encodeURIComponent(event.title),
        body: encodeURIComponent(event.description),
        location: encodeURIComponent(event.location),
        startdt: event.start.toLocaleString("yyyyMMdd'T'HHmmssZZZ"),
        enddt: event.end.toLocaleString("yyyyMMdd'T'HHmmssZZZ")
    }
    return `https://outlook.live.com/owa/?path=/calendar/action/compose#${toQueryString(details)}`;
}

function toOutlook365Link(event) {
    const details = {
        subject: encodeURIComponent(event.title),
        body: encodeURIComponent(event.description),
        location: encodeURIComponent(event.location),
        startdt: event.start.toLocaleString("yyyyMMdd'T'HHmmssZZZ"),
        enddt: event.end.toLocaleString("yyyyMMdd'T'HHmmssZZZ")
    }
    return `https://outlook.office.com/calendar/0/deeplink/compose?${toQueryString(details)}`;
}

exports.toOutlookLink = toOutlookLink;
exports.toOutlook365Link = toOutlook365Link;